// Images
import Mk1DiabloHornStyleRedAndBlackMain from '../../assets/images/products/phoenix-headdress-mk1-diablo-horn-style-red-and-black-main.webp';
import Mk1DiabloHornStyleRedAndBlack1 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-1.webp';
import Mk1DiabloHornStyleRedAndBlack2 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-2.webp';
import Mk1DiabloHornStyleRedAndBlack3 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-3.webp';
import Mk1DiabloHornStyleRedAndBlack4 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-4.webp';
import Mk1DiabloHornStyleRedAndBlack5 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-5.webp';
import Mk1DiabloHornStyleRedAndBlack6 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-6.webp';
import Mk1DiabloHornStyleRedAndBlack7 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-7.webp';
import Mk1DiabloHornStyleRedAndBlack8 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-8.webp';
import Mk1DiabloHornStyleRedAndBlack9 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-9.webp';
import Mk1DiabloHornStyleRedAndBlack10 from '../../assets/images/headdress/phoenix-headdress-mk1-diablo-horn-style-red-and-black-10.webp';
// MK2 Firebird
import Mk2FirebirdFeatheredHeaddressMain from '../../assets/images/products/phoenix-headdress-mk2-firebird-feathered-headdress-main.webp';
import Mk2FirebirdFeatheredHeaddress1 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-1.webp';
import Mk2FirebirdFeatheredHeaddress2 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-2.webp';
import Mk2FirebirdFeatheredHeaddress3 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-3.webp';
import Mk2FirebirdFeatheredHeaddress4 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-4.webp';
import Mk2FirebirdFeatheredHeaddress5 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-5.webp';
import Mk2FirebirdFeatheredHeaddress6 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-6.webp';
import Mk2FirebirdFeatheredHeaddress7 from '../../assets/images/headdress/phoenix-headdress-mk2-firebird-feathered-headdress-7.webp';
// MK3 Beserker
import Mk3BeserkerOrangeFourHornsMain from '../../assets/images/products/phoenix-headdress-mk3-beserker-orange-four-horns-main.webp';
import Mk3BeserkerOrangeFourHorns1 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-1.webp';
import Mk3BeserkerOrangeFourHorns2 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-2.webp';
import Mk3BeserkerOrangeFourHorns3 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-3.webp';
import Mk3BeserkerOrangeFourHorns4 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-4.webp';
import Mk3BeserkerOrangeFourHorns6 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-6.webp';
import Mk3BeserkerOrangeFourHorns7 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-7.webp';
import Mk3BeserkerOrangeFourHorns8 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-8.webp';
import Mk3BeserkerOrangeFourHorns9 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-9.webp';
import Mk3BeserkerOrangeFourHorns10 from '../../assets/images/headdress/phoenix-headdress-mk3-beserker-orange-four-horns-10.webp';
// MK5 Peacock
import Mk5PeacockGreenFeatheredHeaddressMain from '../../assets/images/products/phoenix-headdress-mk5-peacock-green-feathered-headdress-main.webp';
import Mk5PeacockGreenFeatheredHeaddress1 from '../../assets/images/headdress/phoenix-headdress-mk5-peacock-green-feathered-headdress-1.webp';
import Mk5PeacockGreenFeatheredHeaddress2 from '../../assets/images/headdress/phoenix-headdress-mk5-peacock-green-feathered-headdress-2.webp';
import Mk5PeacockGreenFeatheredHeaddress3 from '../../assets/images/headdress/phoenix-headdress-mk5-peacock-green-feathered-headdress-3.webp';
import Mk5PeacockGreenFeatheredHeaddress4 from '../../assets/images/headdress/phoenix-headdress-mk5-peacock-green-feathered-headdress-4.webp';
import Mk5PeacockGreenFeatheredHeaddress5 from '../../assets/images/headdress/phoenix-headdress-mk5-peacock-green-feathered-headdress-5.webp';
import Mk5PeacockGreenFeatheredHeaddress6 from '../../assets/images/headdress/phoenix-headdress-mk5-peacock-green-feathered-headdress-6.webp';
// MK6 Valkyrie
import Mk6ValkyrieWhiteAndGoldMain from '../../assets/images/products/phoenix-headdress-product-no-background-white-and-gold-3.webp';
import Mk6ValkyrieWhiteAndGold1 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-1.webp';
import Mk6ValkyrieWhiteAndGold2 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-2.webp';
import Mk6ValkyrieWhiteAndGold3 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-3.webp';
import Mk6ValkyrieWhiteAndGold4 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-4.webp';
import Mk6ValkyrieWhiteAndGold5 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-5.webp';
import Mk6ValkyrieWhiteAndGold6 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-6.webp';
import Mk6ValkyrieWhiteAndGold7 from '../../assets/images/headdress/phoenix-headdress-mk6-valkyrie-white-and-gold-7.webp';
// MK7 Megatran+
import MK7MegatranMain from '../../assets/images/products/phoenix-headdress-product-no-background-pink-blue-3.webp';
import MK7Megatran1 from '../../assets/images/headdress/phoenix-headdress-mk7-megatran-pride-trans-flat-style-1.webp';
import MK7Megatran2 from '../../assets/images/headdress/phoenix-headdress-mk7-megatran-pride-trans-flat-style-2.webp';
import MK7Megatran3 from '../../assets/images/headdress/phoenix-headdress-mk7-megatran-pride-trans-flat-style-3.webp';
import MK7Megatran4 from '../../assets/images/headdress/phoenix-headdress-mk7-megatran-pride-trans-flat-style-4.webp';
// MK9 Beetlejuice
import Mk8Beetlejuice1 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_fve.webp'
import Mk8Beetlejuice2 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_ohd.webp'
import Mk8Beetlejuice3 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_oni.webp'
import Mk8Beetlejuice4 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_eco.webp'
import Mk8Beetlejuice5 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_mdu.webp'
import Mk8Beetlejuice6 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_ukv.webp'
import Mk8Beetlejuice7 from '../../assets/images/headdress/phoenix-headdress-mk8-beetlejuice-green-neon-headdress_vxi.webp'

export const headdressGalleryGroupsArray = [
  {
    title: 'MK1: Diablo',
    description:
      'A fierce fusion of phoenix rebirth and diabolic power. Charred blacks and blazing reds coil into dramatic, horned silhouettes, radiating unstoppable resilience.',
    images: [
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlackMain,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack1,
      },
      {
        name: 'Phoenix MK2',
        src: Mk1DiabloHornStyleRedAndBlack2,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack3,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack4,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack5,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack6,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack7,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack8,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack9,
      },
      {
        name: 'MK1 Diablo',
        src: Mk1DiabloHornStyleRedAndBlack10,
      },
    ],
  },
  {
    title: 'MK2: Firebird',
    description:
      'Bold color-blocking, electrified lines, and mythic energy flow through this avant-garde design. This piece channels futuristic fashion and divine rebellion.',
    images: [
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddressMain },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress1 },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress2 },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress3 },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress4 },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress5 },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress6 },
      { name: 'MK2 Firebird', src: Mk2FirebirdFeatheredHeaddress7 },
    ],
  },
  {
    title: 'MK3: Beserker',
    description:
      'Unleashing primal fury through sharp edges and volcanic colorways, this four-horned design commands attention with bold structure and unapologetic presence.',
    images: [
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHornsMain },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns1 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns2 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns3 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns4 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns6 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns7 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns8 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns9 },
      { name: 'MK3 Beserker', src: Mk3BeserkerOrangeFourHorns10 },
    ],
  },
  {
    title: 'MK5: Peacock',
    description:
      'Elegant and hypnotic, this feathered masterpiece draws from the deep iridescence of peacock plumage. A regal silhouette for those who demand attention with grace.',
    images: [
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddressMain },
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddress1 },
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddress2 },
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddress3 },
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddress4 },
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddress5 },
      { name: 'MK5 Peacock', src: Mk5PeacockGreenFeatheredHeaddress6 },
    ],
  },
  {
    title: 'MK6: Valkyrie',
    description:
      'Radiating divine power, this white and gold design channels the majesty of celestial warriors. Clean symmetry and shining accents create a look of purity and strength.',
    images: [
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGoldMain },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold1 },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold2 },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold3 },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold4 },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold5 },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold6 },
      { name: 'MK6 Valkyrie', src: Mk6ValkyrieWhiteAndGold7 },
    ],
  },
  {
    title: 'MK7: Megatran',
    description:
      'A vibrant celebration of pride, identity, and transformation. Inspired by the colours of the pride flag, this radiant headdress weaves together pink, white, and royal blue in a bold expression of self-love, unity, and unapologetic visibility.',
    images: [
      { name: 'MK7 Megatran', src: MK7MegatranMain },
      { name: 'MK7 Megatran', src: MK7Megatran1 },
      { name: 'MK7 Megatran', src: MK7Megatran2 },
      { name: 'MK7 Megatran', src: MK7Megatran3 },
      { name: 'MK7 Megatran', src: MK7Megatran4 },
    ],
  },
  {
    title: 'MK8: Beetlejuice',
    description:
      'A emerald shining bright! A green and neon style of earthly colours and love. Called the Beetlejuice and designed for a halloween event.',
    images: [
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice1 },
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice2 },
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice3 },
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice4 },
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice5 },
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice6 },
      { name: 'MK8 Beetlejuice', src: Mk8Beetlejuice7 },
    ],
  },
];
